{
  /* <span style=\"text-decoration: underline;\"> */
}
import React from 'react';
import { arrayOf, bool, func, node, number, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { LinkedLogo, NamedLink } from '../../../../components';

import { FormattedMessage, intlShape } from '../../../../util/reactIntl';

import Field from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionFooter.module.css';
import dfGipuzkoaImg from '../../../../assets/logos/df_gipuzkoa.png';
import ministImg from '../../../../assets/logos/ministeriocul.jpeg';
import prtrImg from '../../../../assets/logos/prtr.png';
import euImg from '../../../../assets/logos/eu.png';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

// The number of columns (numberOfColumns) affects styling

const GRID_CONFIG = [
  { contentCss: css.contentCol1, gridCss: css.gridCol1 },
  { contentCss: css.contentCol2, gridCss: css.gridCol2 },
  { contentCss: css.contentCol3, gridCss: css.gridCol3 },
  { contentCss: css.contentCol4, gridCss: css.gridCol4 },
];

const getIndex = numberOfColumns => numberOfColumns - 1;

const getContentCss = numberOfColumns => {
  const contentConfig = GRID_CONFIG[getIndex(numberOfColumns)];
  return contentConfig ? contentConfig.contentCss : GRID_CONFIG[0].contentCss;
};

const getGridCss = numberOfColumns => {
  const contentConfig = GRID_CONFIG[getIndex(numberOfColumns)];
  return contentConfig ? contentConfig.gridCss : GRID_CONFIG[0].gridCss;
};

// Section component that's able to show blocks in multiple different columns (defined by "numberOfColumns" prop)
const SectionFooter = props => {
  const {
    sectionId,
    className,
    rootClassName,
    numberOfColumns,
    socialMediaLinks,
    slogan,
    appearance,
    copyright,
    blocks,
    options,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const linksWithBlockId = socialMediaLinks?.map(sml => {
    return {
      ...sml,
      blockId: sml.link.platform,
    };
  });

  const showSocialMediaLinks = false;
  // socialMediaLinks?.length > 0;

  // use block builder instead of mapping blocks manually

  return (
    <SectionContainer
      as="footer"
      id={sectionId}
      className={className || css.root}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      <div className={css.footer}>
        <div className={css.content}>
          <ul>
            <li>
              <NamedLink name="AboutUsPage">
                <FormattedMessage id="Footer.aboutUs" />
              </NamedLink>
            </li>
            {/* <li>
              <a>
                <FormattedMessage id="Footer.supportCenter" />
              </a>
            </li> */}
            <li>
              <Link to="/blog/search?category=all-articles">
                <FormattedMessage id="Footer.blog" />
              </Link>
            </li>
            <li>
              <NamedLink name="FAQsPage">
                <FormattedMessage id="Footer.faqs" />
              </NamedLink>
            </li>
            <li>
              <NamedLink name="InsurancePage">
                <FormattedMessage id="Footer.seguro" />
              </NamedLink>
            </li>
          </ul>
          <ul>
            <li>
              <NamedLink name="LegalNoticePage">
                <FormattedMessage id="Footer.legalNotice" />
              </NamedLink>
            </li>
            <li>
              <NamedLink name="CookiePolicyPage">
                <FormattedMessage id="Footer.cookiePolicy" />
              </NamedLink>
            </li>
            <li>
              <NamedLink name="PrivacyPolicyPage">
                <FormattedMessage id="Footer.privacyPolicy" />
              </NamedLink>
            </li>
            <li>
              <NamedLink name="TermsOfServicePage">
                <FormattedMessage id="Footer.termsAndConditions" />
              </NamedLink>
            </li>
          </ul>
          <ul className={css.footerLogosList}>
            <li>
              <div className={css.footerOfficialWrapper}>
                <img src={dfGipuzkoaImg} className={css.footerOfficialLogo} />
              </div>
            </li>
            <li>
              <div className={css.footerOfficialWrapper}>
                <img src={ministImg} className={css.footerOfficialLogo} />
              </div>
            </li>
          </ul>
          <ul className={css.footerLogosList}>
            <li>
              <div className={css.footerOfficialWrapper}>
                <img src={prtrImg} className={css.footerOfficialLogo} />
              </div>
            </li>
            <li>
              <div className={css.footerOfficialWrapper}>
                <img src={euImg} className={css.footerOfficialLogo} />
              </div>
            </li>
          </ul>
        </div>
        <div className={css.copyright}>
          <span>
            © Aloka, <FormattedMessage id="Footer.allRightsReserved" />.
          </span>
          {showSocialMediaLinks ? (
            <div className={css.icons}>
              <BlockBuilder blocks={linksWithBlockId} options={options} />
            </div>
          ) : null}
        </div>
      </div>
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionFooter.defaultProps = {
  className: null,
  rootClassName: null,
  textClassName: null,
  numberOfColumns: 1,
  socialMediaLinks: [],
  slogan: null,
  copyright: null,
  appearance: null,
  blocks: [],
  options: null,
};

SectionFooter.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  numberOfColumns: number,
  socialMediaLinks: arrayOf(object),
  slogan: object,
  copyright: object,
  appearance: object,
  blocks: arrayOf(object),
  options: propTypeOption,
};

export default SectionFooter;
